import { render, staticRenderFns } from "./Estimation_Details.vue?vue&type=template&id=c6ec983a&scoped=true&"
import script from "./Estimation_Details.vue?vue&type=script&lang=js&"
export * from "./Estimation_Details.vue?vue&type=script&lang=js&"
import style0 from "./Estimation_Details.vue?vue&type=style&index=0&id=c6ec983a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ec983a",
  null
  
)

export default component.exports